import { render, staticRenderFns } from "./docCate.vue?vue&type=template&id=2117b6ca&scoped=true"
import script from "./docCate.vue?vue&type=script&lang=js"
export * from "./docCate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2117b6ca",
  null
  
)

export default component.exports